import { viewedLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/viewed-logged-out-page';
import { usePublicWeddingWebsite } from '@bridebook/web/app-basic/lib/wedding-website/hooks/use-public-wedding-website';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { Container } from '@bridebook/ui';
import FooterBottom from '@bridebook/web/app-shared/components/footer/footer-bottom/footer-bottom';
import FullpageLoader from '@bridebook/web/app-shared/components/fullpage-loader/fullpage-loader';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { PropsWithChildren, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PasswordPage } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/password-page/password-page';
import { WeddingWebsiteDataContext } from './data-context';
import { EditorSyncProvider } from '../../../main/desktop/editor-sync-context';

export const DataProviderGuest = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation('weddingWebsite');
  const router = useRouter();
  const { websiteId } = router.query as { websiteId: string };
  const [pin, setPin] = useState('');

  const { data, isLoading, isFetching } = usePublicWeddingWebsite(
    websiteId,
    {
      ...(pin && {
        pin,
      }),
    },
    {
      keepPreviousData: true,
    },
  );

  if (isLoading) {
    return <FullpageLoader />;
  }

  if (!data) {
    return <div>{t('guestView.errorLoadingWebsite')}</div>;
  }

  // Show password entry if pin is missing or invalid
  if (data.resultCode === 'pin_missing' || data.resultCode === 'invalid_pin') {
    return <PasswordPage websiteData={data} isFetching={isFetching} onPasswordEntered={setPin} />;
  }

  if (data.resultCode === 'ok') {
    return (
      <EditorSyncProvider noop>
        <WeddingWebsiteDataContext.Provider
          value={{
            website: data.website,
            wedding: data.wedding,
            events: data.events,
            suppliers: data.suppliers,
            photosBySupplier: data.photosBySupplier,
            isGuestView: true,
          }}>
          <GuestViewTracker />
          {children}
        </WeddingWebsiteDataContext.Provider>
        <div className="relative z-10 bg-white">
          <Container>
            <FooterBottom localeSelect={null} />
          </Container>
        </div>
      </EditorSyncProvider>
    );
  }

  // Fallback error state
  return <div>{t('guestView.errorLoadingWebsite')}</div>;
};

const GuestViewTracker = () => {
  const dispatch = useDispatch();
  const { country } = useMarket();

  useEffect(() => {
    dispatch(
      viewedLoggedOutPage({
        title: document.title,
        selectedWeddingCountry: country,
        trackingTarget: 'BigQuery',
      }),
    );
  }, [dispatch, country]);

  return null;
};
